import { call, put, takeEvery } from "redux-saga/effects";
import {
  createBusinessEmailTemplateFail,
  createBusinessEmailTemplateSuccess,
  deleteBusinessEmailTemplateFail,
  deleteBusinessEmailTemplateSuccess, getBusinessEmailTemplateDetailsFail,
  getBusinessEmailTemplateDetailsSuccess,
  getBusinessEmailTemplateFail,
  getBusinessEmailTemplateSuccess,
  updateBusinessEmailTemplateFail,
  updateBusinessEmailTemplateSuccess
} from "./action";
import {
  CREATE_BUSINESS_EMAIL_TEMPLATE, DELETE_BUSINESS_EMAIL_TEMPLATE, GET_BUSINESS_EMAIL_TEMPLATE_DETAILS,
  GET_BUSINESS_EMAIL_TEMPLATES,
  UPDATE_BUSINESS_EMAIL_TEMPLATE
} from "./actionTypes";
import EmailTemplateService from "../../services/EmailTemplateService";

function* fetchBusinessEmailTemplates({ type, payload }) {

  try {
    const response = yield call(EmailTemplateService.listEmailTemplate, payload)
    yield put(getBusinessEmailTemplateSuccess(response))
  } catch (error) {
    yield put(getBusinessEmailTemplateFail(error))
  }
}

function* fetchBusinessEmailTemplateDetails({ type, payload }) {
  try {
    const response = yield call(EmailTemplateService.detailsEmailTemplate, payload)
    yield put(getBusinessEmailTemplateDetailsSuccess(response))
  } catch (error) {
    yield put(getBusinessEmailTemplateDetailsFail(error))
  }
}

function* createBusinessEmailTemplates({ type, payload }) {

  try {
    const response = yield call(EmailTemplateService.createEmailTemplate, payload)
    yield put(createBusinessEmailTemplateSuccess(response))
  } catch (error) {
    yield put(createBusinessEmailTemplateFail(error))
  }
}

function* updateBusinessEmailTemplates({ type, payload }) {

  try {
    const response = yield call(EmailTemplateService.updateEmailTemplate, payload)
    yield put(updateBusinessEmailTemplateSuccess(response))
  } catch (error) {
    yield put(updateBusinessEmailTemplateFail(error))
  }
}

function* deleteBusinessEmailTemplates({ type, payload }) {

  try {
    const response = yield call(EmailTemplateService.deleteEmailTemplate, payload)
    yield put(deleteBusinessEmailTemplateSuccess(payload.emailTemplateId))
  } catch (error) {
    yield put(deleteBusinessEmailTemplateFail(error))
  }
}

function* businessEmailTemplatesSaga() {
  yield takeEvery(GET_BUSINESS_EMAIL_TEMPLATES, fetchBusinessEmailTemplates);
  yield takeEvery(GET_BUSINESS_EMAIL_TEMPLATE_DETAILS, fetchBusinessEmailTemplateDetails);
  yield takeEvery(CREATE_BUSINESS_EMAIL_TEMPLATE, createBusinessEmailTemplates);
  yield takeEvery(UPDATE_BUSINESS_EMAIL_TEMPLATE, updateBusinessEmailTemplates);
  yield takeEvery(DELETE_BUSINESS_EMAIL_TEMPLATE, deleteBusinessEmailTemplates);
}

export default businessEmailTemplatesSaga;
